var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":_vm.includeArr}},[_c('router-view',{key:_vm.$route.fullPath,staticClass:"viewer"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }